import brand from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
export const SectionWrapperCSS = css `
  color: var(--sectionColour, ${brand.primary.black});
  background: var(--sectionBackground, transparent);
  scroll-margin: var(--headerHeight, 0px) 0 0;

  &[data-flush='top'] {
    --sectionSpacingTop: 0;
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;
  }

  /* Variant text colours */
  &[data-variant='blue'],
  &[data-variant='charcoal'],
  &[data-variant='orange'],
  &[data-variant='pink'] {
    --sectionColour: ${brand.primary.white};
  }

  &[data-variant='stone'],
  &[data-variant='white'] {
    --sectionColour: ${brand.primary.black};
  }

  /* Variant background colours */
  &[data-variant='pink'] {
    --bgAngle: 90deg;
  }

  &[data-variant='blue'],
  &[data-variant='charcoal'] {
    --bgAngle: 105deg;
  }

  &[data-variant='orange'] {
    --bgAngle: 0deg;
  }

  &[data-variant='blue'] {
    --sectionBackground: linear-gradient(var(--bgAngle), #3372aa 0%, #1e2f6d 100%);
  }

  &[data-variant='charcoal'] {
    --sectionBackground: linear-gradient(var(--bgAngle), #2b2b2b 0%, #505050 100%);
  }

  &[data-variant='orange'] {
    --sectionBackground: linear-gradient(var(--bgAngle), #f47929 0%, #f17028 58.6%, #e24321 98.36%);
  }

  &[data-variant='pink'] {
    --sectionBackground: linear-gradient(var(--bgAngle), #9f4a92 0%, #cc709c 53%, #f491a4 100%);
  }

  &[data-variant='stone'] {
    --sectionBackground: ${brand.primary.stone};
  }

  &[data-variant='white'] {
    --sectionBackground: ${brand.primary.white};
  }
`;
const Container = styled(m.section) `
  ${SectionWrapperCSS};
`;
export const SectionWrapperInnerCSS = css `
  ${siteWide};

  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);
`;
const Inner = styled.div `
  ${SectionWrapperInnerCSS};
`;
const SectionWrapperStyles = {
    Container,
    Inner,
};
export default SectionWrapperStyles;
